import React, { useEffect, useState } from "react";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useGlobal from "../../../util/Global";
import Accountservice from "../../../service/Core/AccountService";
import StorageUtils from "../../../ui/StorageUtils";
import EbasvuruTenantservice from "../../../service/Ebasvuru/EbasvuruTenantService";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useQuery from "../../../util/useQuery";
import useMessage from "../../../util/useMessagev2";
import CountdownTimer from "../../../components/CountdownTimer";
import { LinkButton } from "../../../components/reusedStyle/buttonStyle";
import { useDispatch } from "react-redux";
import { ActionType } from "../../../store/ActionType";
import { useAppCookies } from "../../../util/useAppCookies";



// styles/fonts.js or in your theme
const defaultFontFamily = `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`;


const AdayConfirmKodu = () => {

    const [canResend, setCanResend] = useState(false);
    const [key, setKey] = useState(0);
    const [aday, setAday] = useState(null);
    const [kalanSyn, setKalanSyn] = useState(0);
    const [loading, setLoading] = useState(true);

    const { t } = useGlobal();
    const query = useQuery();
    const showMessage = useMessage();
    const history = useHistory();
    const dispatch = useDispatch();
    const { setUser } = useAppCookies();

    const id = query.get("id");

    const schema = yup.object().shape({
        girisKodu: yup
            .number()
            .typeError(`${t('col.girisKodu')} sayısal bir değer olmalıdır`)
            .required(`Lütfen ${t('col.girisKodu')} giriniz`)
    });

    const goTo = (props) => {
        history.push(`/${props.page}`);
    }

    const { register, handleSubmit, formState: { errors, isValid } } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    })

    const onSubmit = async (formdata) => {



        setLoading(true);

        const { isSuccess, token, data, user } = await Accountservice.loginAsAdayByCode(
            {
                _code: formdata.girisKodu,
                _tcKimlikNo: aday.tcKimlikNo,
                _ipAdresi: aday.adayIp
            }, aday.token);

        if (!isSuccess) {
            showMessage.error(t('message.girisKoduError'))
            return;
        }



        const adayUser = {
            accessToken: data.token,
            loginType: "aday",
            tenantName: user.masterTenant.name,
            tenantIcon: user.masterTenant.iconUrl,
            masterToken: data.token,
            userId: user.id,
            basvuruId: aday.basvuruId,
            iapId: aday.iapId,
            adSoyad: aday.adSoyad,
            tenantKey: aday.tenantKey
        }



        setUser(adayUser);

        dispatch({
            type: ActionType.ADAY_LOGIN,
            accessToken: data.token,
            loginType: "aday",
            tenantName: user.masterTenant.name,
            tenantIcon: user.masterTenant.iconUrl,
            masterToken: data.token,
            userId: user.id,
            basvuruId: aday.basvuruId,
            iapId: aday.iapId,
            user: adayUser,
            tenantKey: aday.tenantKey
        });

        history.push("/");

        setLoading(false);
    }

    useEffect(() => {

        const adayUser = StorageUtils.get("aday");

        const sendTime = adayUser?.sendTime ? new Date(adayUser.sendTime).getTime() : 0;
        const now = Date.now(); // Current time in milliseconds
        var Syn = Math.max(120 - Math.floor((now - sendTime) / 1000), 0); // Convert ms to sec, ensure non-negative
        setKalanSyn(Syn);
        setCanResend(false);
        setKey((prev) => prev + 1);

        setAday(adayUser);

        if (adayUser) {
            Accountservice.loginAsAday({ tenant: adayUser.tenantKey })
                .then((res) => {
                    if (res?.token) {
                        EbasvuruTenantservice.setToken(res.token);
                    }
                })
                .catch((err) => console.error("Login failed:", err));
        }

    }, []);

    const handleResend = () => {


        EbasvuruTenantservice.SendSMS(
            {
                aday: {
                    adayId: aday.id,
                    cepTel: aday.cepTel,
                    tCKN: aday.tcKimlikNo,
                    ad: aday.ad,
                    Soyad: aday.soyad,

                },
                tel: aday.cepTel,
                adayIPAdresi: aday.adayIp,
                iletisimSenaryosu: 1, // LoginOnayKoduSMS
            }).then((res) => {

                if (res && res.isSuccess) {
                    setKalanSyn(120);
                    setCanResend(false);
                    setKey((prev) => prev + 1);
                }


            });


    };





    return (
        <Box
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 5 }}>
            <Grid container spacing={4} maxWidth="90%" sx={{ alignItems: "center" }}>
                <Grid item xs={12} sm={12} >
                    <img
                        src="/securitas-logo-forwhitebackground.svg" // Replace with actual image path
                        style={{ width: "100px", borderRadius: "8px" }}
                    />
                    <span style={{ marginleft: "15px", color: "#888888", fontsize: "20px" }}>
                        {t("title.EbasvuruPortal")}
                    </span>
                </Grid>




                <Grid item sx={12}>
                    <Grid container spacing={5} >
                        <Grid item xs={12} sm={12} md={12} lg={7} sx={{ textAlign: 'center' }} >
                            <img
                                src="/sec-login-idari.png" // Replace with actual image path
                                alt={t("title.SecuritasTeam")}
                                style={{
                                    width: "40vw",

                                    height: 'auto',

                                }}
                            />
                        </Grid>


                        {/* Right Side - Form */}
                        <Grid item xs={12} sm={12} md={12} lg={5} sx={{ textAlign: "left", pl: '5vw', pr: '5vw' }} >
                            <Grid container sx={{ marginleft: 10 }} >
                                <Grid item xs={12} sx={{ mt: 5 }}>
                                    <Typography variant="caption" sx={{
                                        color: "#949494",
                                        fontSize: 12, padding: 0,
                                        fontFamily: defaultFontFamily
                                    }}>

                                        {t("title.giriskodu")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        placeholder={t('col.basvurOnayKodu')}
                                        sx={{ mt: 0 }}
                                        {...register("girisKodu")}
                                        error={!!errors.girisKodu}
                                        helperText={errors.girisKodu?.message}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2" sx={{ mt: 1, color: "#666", fontSize: '0.9rem' }}>
                                        {aday?.cepTel} {t("title.onayMessage")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    {/* Login Code Button */}
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        color="error"
                                        sx={{ mt: 3, bgcolor: "#c00" }}
                                        type="submit"
                                        disabled={!isValid}
                                    >
                                        {t("action.devamEt")}
                                    </Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box>
                                        <Typography gap={2} sx={{ color: "#949494", fontSize: 11, padding: 0 }}>
                                            {t('title.giriskodunun')}

                                            <Button onClick={handleResend} disabled={!canResend} sx={LinkButton}>
                                                {"  " + t("title.ResendKod")}
                                            </Button>


                                        </Typography >
                                        {
                                            !canResend && <CountdownTimer key={key} initialTime={kalanSyn} onComplete={() => { setCanResend(true) }} />
                                        }
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box >
    );

}

export default AdayConfirmKodu;